

<template>

	<transition name="slide-fade">


		<section class="col-xs-12 block bgg formconfi">
			<div class="container min">
				<div class="row" v-html="pagina.content.rendered">

				</div>
			</div>
		</section>


	</transition>

</template>

<script>
export default {
	props:[
		'pagina',
	],
	mounted: function() {
		// this.getPage();
	},
	data() {
		return {
			page: {},
			page_childrens: {},
			loaded: 'false',
			loaded_childrens: 'false',
			pageTitle: ''
		};
	},
	methods: {

	},
	watch: {
		'$route'( to, from ) {
			// react to route changes...
			// this.getPage();
		}
	}
};
</script>



// WEBPACK FOOTER //
// page_formulario.vue?5b9777b8